import { render, staticRenderFns } from "./arrows-left-outlined.vue?vue&type=template&id=377c281f&scoped=true&"
var script = {}
import style0 from "./arrows-left-outlined.vue?vue&type=style&index=0&id=377c281f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c281f",
  null
  
)

export default component.exports